import { render, staticRenderFns } from "./IssueTrackingLog.vue?vue&type=template&id=05d34a7c&"
import script from "./IssueTrackingLog.vue?vue&type=script&lang=ts&"
export * from "./IssueTrackingLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports